export default "__VITE_ASSET__aefc6f9e__"